import { User } from '../../types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useProfile() {
  const url = `/api/v1/profile`;
  const request = new Request(url);

  return useAuthenticatedRequest<User>(request, {
    queryKey: ['user', 'profile'],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson;
    },
  });
}

export default useProfile;
